import React from 'react';
import './style.css';

const CustomButton = ({text, className="", ...props}) => {
  //{`${disabled}`}
 return (
    <button className={`custom-button ${className}`} {...props}>
      {text}
    </button>
    ) 
};

export default CustomButton;